export default class XError extends Error 
{
    constructor(name, message, ...data) 
    {
        super(message);
        this.name = name;
        this.data = data;
        if(Error.captureStackTrace) 
        {
            Error.captureStackTrace(this, XError);
        }
    }
}

export class XTypeError extends XError 
{
    constructor(message, ...data) 
    {
        super('XTypeError', message, ...data);
    }
}

export function xHandleXErrors()
{
    window.onerror = function (message, source, lineno, colno, error) 
    {
        if(error instanceof XError)
        {
            console.error(error.message, error.data);
        }
        return false;
    };

    window.addEventListener("unhandledrejection", function (event) 
    {
        event.promise.catch((error) => 
        {
            console.error(error.message, error.data);
        });
    });
}